import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Link from "../../../../../../components/Link/Link";

export interface ReadonlyPromotionIdBlockProps {
  promotionId: string;
}

const ReadonlyPromotionIdBlock = ({
  promotionId,
}: ReadonlyPromotionIdBlockProps) => {
  const { t } = useTranslation("orders");
  const theme = useTheme();

  return (
    <Box data-testid="readonly-promotion-id-block" sx={{ textAlign: "left" }}>
      <Typography
        sx={{
          fontWeight: theme.tokens.FuelFontWeightSemibold,
          paddingBottom: theme.tokens.FuelSpacing2,
        }}
      >
        {t("orderSummary.header.promotion")}
      </Typography>
      <Link
        data-testid="readonly-promotion-id"
        to={`/promotions/${promotionId}`}
      >
        {promotionId}
      </Link>
    </Box>
  );
};

export default ReadonlyPromotionIdBlock;
